import { GetRouteRequestModel, GetRouteResponseModel } from '@/models';
import { CheckRouteRequestModel } from './models';

export const mapCheckRouteRequestModel = (req: CheckRouteRequestModel) => {
  return new CheckRouteRequestModel(req);
};
export const mapGetRouteRequestModel = (req: GetRouteRequestModel) => {
  return new GetRouteRequestModel(req);
};
export const mapGetRouteResponseModel = (req: GetRouteResponseModel) => {
  return new GetRouteResponseModel(req);
};
